import { React, useState, useEffect } from 'react';
import { useNavigate, useLocation, useParams } from 'react-router-dom';

import { urls, getCsrfToken } from '../com.zedock.common.script/urls.js';
import { clicks } from '../com.zedock.common.script/common.js';

import '../com.zedock.common.style/AboutUs.css';
import '../com.zedock.common.style/common.css';

function AboutUs() {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    clicks(location.pathname);
    window.scrollTo({ top: 0, behavior: 'instant' });
  }, []);

  return (

    <div className="container px-0    ">


            <div className="zd-wrap p-2 p-lg-4">

        <div className="row">
          <nav aria-label="breadcrumb" className="zd-crumb">
            <ol className="breadcrumb mb-0">
              <li className="breadcrumb-item">
                <a href="" onClick={(e) => { e.preventDefault(); navigate("/Product") }}>Home</a>
              </li>
              <li className="breadcrumb-item active" aria-current="page">About Us</li>
            </ol>
          </nav>
        </div>

        <div className="zd-about-head">
          <span className="zd-about-eyebrow">Good to know</span>
          <h2>About Zedock</h2>
          <p>Everything you need to know about shopping, shipping, and returns with us.</p>
        </div>

        {/* ---------------- FAQ highlight cards ---------------- */}
        <div className="row   g-2 mb-2">

          <div className="col-12 col-lg-4">
            <div className="zd-faq-card">
              <div className="zd-faq-imgwrap">
                <img src="https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?auto=format&fit=crop&w=700&q=80" alt="Returns and refunds" />
              </div>
              <div className="zd-faq-body">
                <h5>How do I receive a refund for a returned product?</h5>
                <p>We refund the amount once your product reaches our warehouse and passes quality check — the full process takes 1-2 weeks after pickup.</p>
                <span className="zd-faq-meta">Updated 5 mins ago</span>
              </div>
            </div>
          </div>

          <div className="col-12 col-lg-4">
            <div className="zd-faq-card">
              <div className="zd-faq-imgwrap">
                <img src="https://images.unsplash.com/photo-1607082349566-187342175e2f?auto=format&fit=crop&w=700&q=80" alt="Shipping charges" />
              </div>
              <div className="zd-faq-body">
                <h5>Do I need to pay for shipping?</h5>
                <p>A small ₹50 shipping charges may applies to certain orders, plus ₹50 for Cash on Delivery — this keeps our courier partners reliable and secure at every touchpoint.</p>
                <span className="zd-faq-meta">Updated 4 days ago</span>
              </div>
            </div>
          </div>

          <div className="col-12 col-lg-4">
            <div className="zd-faq-card">
              <div className="zd-faq-imgwrap">
                <img src="https://images.unsplash.com/photo-1586528116311-ad8dd3c8310d?auto=format&fit=crop&w=700&q=80" alt="Order delivery" />
              </div>
              <div className="zd-faq-body">
                <h5>When will I receive my order?</h5>
                <p>Our fulfilment partners aim for timely, accurate delivery. Depending on your location, expect your order within 5 to 7 days.</p>
                <span className="zd-faq-meta">Updated 1 hour ago</span>
              </div>
            </div>
          </div>

        </div>

        {/* ---------------- accordion ---------------- */}
        <div className="row   g-2 mb-2">
          <div className="col-12">
            <div className="zd-faq-section-head">
              <h3>More about Zedock</h3>
              <span>4 topics</span>
            </div>

            <div className="accordion zd-accordion" id="accordionPanelsStayOpenExample">

              <div className="accordion-item">
                <h2 className="accordion-header">
                  <button className="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#panelsStayOpen-collapseOne" aria-expanded="true" aria-controls="panelsStayOpen-collapseOne">
                    Latest Trends
                  </button>
                </h2>
                <div id="panelsStayOpen-collapseOne" className="accordion-collapse collapse show">
                  <div className="accordion-body">
                    Stay ahead of the curve with Zedock’s curated picks.
                    From everyday essentials to premium collections, we showcase what’s new and exciting across categories.
                    Whether it’s innovative designs, sustainable options, or timeless classics making a comeback, Zedock ensures you never miss what’s trending.
                    Explore products that blend practicality with style, perfect for daily use or special occasions.
                  </div>
                </div>
              </div>

              <div className="accordion-item">
                <h2 className="accordion-header">
                  <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#panelsStayOpen-collapseTwo" aria-expanded="false" aria-controls="panelsStayOpen-collapseTwo">
                    Premium Selections
                  </button>
                </h2>
                <div id="panelsStayOpen-collapseTwo" className="accordion-collapse collapse">
                  <div className="accordion-body">
                    Elevate your lifestyle with items that speak quality and sophistication.
                    Zedock offers carefully chosen products — from durable gadgets to elegant décor — each selected to complement your needs.
                    Our premium range combines reliability with design, ensuring you invest in things that last while making a bold statement.
                    Discover items that transform simple choices into standout experiences.
                  </div>
                </div>
              </div>

              <div className="accordion-item">
                <h2 className="accordion-header">
                  <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#panelsStayOpen-collapseThree" aria-expanded="false" aria-controls="panelsStayOpen-collapseThree">
                    Seasonal Collections
                  </button>
                </h2>
                <div id="panelsStayOpen-collapseThree" className="accordion-collapse collapse">
                  <div className="accordion-body">
                    Timing matters, and Zedock brings you collections tailored for every season.
                    Cozy winter essentials, breezy summer picks, festive specials, and monsoon‑ready must‑haves — all in one place.
                    Each seasonal drop is curated to match the mood, climate, and cultural vibe of the moment.
                    With exclusive limited‑edition releases, you’ll always find something fresh to keep your lifestyle updated year‑round.
                  </div>
                </div>
              </div>

              <div className="accordion-item">
                <h2 className="accordion-header">
                  <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#panelsStayOpen-collapseTwo1" aria-expanded="false" aria-controls="panelsStayOpen-collapseTwo1">
                    Exclusive Offers
                  </button>
                </h2>
                <div id="panelsStayOpen-collapseTwo1" className="accordion-collapse collapse">
                  <div className="accordion-body">
                    Shopping at Zedock means more than just choice — it means value.
                    Unlock discounts on top brands, enjoy bundle deals, and grab limited‑time promotions across categories.
                    Our exclusive offers are designed to give you the best shopping experience without compromise.
                    Whether it’s festive sales, loyalty rewards, or flash deals, Zedock ensures you save while enjoying the best products. </div>
                </div>
              </div>

            </div>
          </div>
        </div>

      </div>


    </div>
  );
}

export default AboutUs;
